import React from "react";
import SearchParams from '../Elements/SearchParams';
import FreelancerPaymentExportSearchParams from '../Contents/FreelancerInvoicing/FreelancerPaymentExport/FreelancerPaymentExportSearchParams';
import FreelancerPaymentExportItem from "../Domain/FreelancerPaymentExportItem";
import AuthService from "./authService.js";

class FreelancerPaymentExportService extends React.Component {
  static GetFreelancerPaymentExportList(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, FreelancerPaymentExportSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/FreelancerPaymentExport/GetFreelancerPaymentExportList?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    var convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        var newItem = new FreelancerPaymentExportItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GeneratePaymentExportFile(freelancerPaymentExportId) {
    let url = '/api/FreelancerPaymentExport/GeneratePaymentExportFile/' + freelancerPaymentExportId;

    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default FreelancerPaymentExportService;
